import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Search } from "lucide-react";
import { siteInfo } from "../mock/mock";

const Contact = () => {
  const telHref = `tel:${siteInfo.phone.replace(/\s/g, "")}`;
  const waHref = `https://wa.me/91${siteInfo.phone.replace(/\D/g, "")}`;
  const priceUrl = siteInfo.checkPricesUrl;

  return (
    <section id="contact" className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-[0.2em]">
            Contact Us
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-black text-neutral-900 leading-tight tracking-tight">
            Contact RR Bros — <span className="text-orange-500">Bike Rental Udupi &amp; Manipal</span>
          </h2>
          <p className="mt-4 text-neutral-600">
            Call or WhatsApp us anytime for bike hire in Udupi or scooty rental
            in Manipal — we&apos;ll get your ride ready in no time.
          </p>
        </div>

        {/* Contact cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <a
            href={telHref}
            className="group bg-neutral-50 hover:bg-orange-50 border border-neutral-100 hover:border-orange-200 rounded-2xl p-6 flex flex-col items-center text-center transition-all"
          >
            <div className="w-14 h-14 rounded-full bg-orange-100 group-hover:bg-orange-500 flex items-center justify-center mb-4 transition-colors">
              <Phone className="w-6 h-6 text-orange-600 group-hover:text-white transition-colors" />
            </div>
            <p className="text-xs text-neutral-500 font-semibold uppercase tracking-wider">
              Call Us
            </p>
            <p className="font-bold text-neutral-900 text-lg mt-1">
              {siteInfo.phoneDisplay}
            </p>
          </a>

          <a
            href={waHref}
            target="_blank"
            rel="noreferrer"
            className="group bg-neutral-50 hover:bg-green-50 border border-neutral-100 hover:border-green-200 rounded-2xl p-6 flex flex-col items-center text-center transition-all"
          >
            <div className="w-14 h-14 rounded-full bg-green-100 group-hover:bg-green-500 flex items-center justify-center mb-4 transition-colors">
              <MessageCircle className="w-6 h-6 text-green-600 group-hover:text-white transition-colors" />
            </div>
            <p className="text-xs text-neutral-500 font-semibold uppercase tracking-wider">
              WhatsApp
            </p>
            <p className="font-bold text-neutral-900 text-lg mt-1">
              Chat with us
            </p>
          </a>

          <a
            href={`mailto:${siteInfo.email}`}
            className="group bg-neutral-50 hover:bg-orange-50 border border-neutral-100 hover:border-orange-200 rounded-2xl p-6 flex flex-col items-center text-center transition-all"
          >
            <div className="w-14 h-14 rounded-full bg-orange-100 group-hover:bg-orange-500 flex items-center justify-center mb-4 transition-colors">
              <Mail className="w-6 h-6 text-orange-600 group-hover:text-white transition-colors" />
            </div>
            <p className="text-xs text-neutral-500 font-semibold uppercase tracking-wider">
              Email
            </p>
            <p className="font-bold text-neutral-900 text-sm mt-1 break-all">
              {siteInfo.email}
            </p>
          </a>
        </div>

        {/* Branches strip */}
        <div className="mt-8 bg-neutral-900 text-white rounded-2xl p-6 sm:p-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-xs text-orange-400 font-bold uppercase tracking-wider">
                Udupi Branch
              </p>
              <p className="font-semibold mt-1 leading-snug">
                {siteInfo.addressUdupi}
              </p>
              <p className="text-xs text-neutral-400 mt-1">
                Mon-Sun · 07:30 AM - 07:30 PM
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-xs text-orange-400 font-bold uppercase tracking-wider">
                Manipal Branch
              </p>
              <p className="font-semibold mt-1 leading-snug">
                {siteInfo.addressManipal}
              </p>
              <p className="text-xs text-neutral-400 mt-1">
                Mon-Sun · 09:00 AM - 07:30 PM
              </p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mt-8 text-center">
          <a
            href={priceUrl}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm uppercase tracking-wider shadow-lg hover:shadow-orange-300/40 transition-all"
          >
            <Search className="w-4 h-4" />
            Search Scooters
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
